// Clicking an @mention opens the DIRECT conversation with that person (user request 2026-10-06,
// MacConversationView.openLink / Android TeamWorkspaceScreen.openUser); the profile card is only the
// fallback when that conversation cannot be opened (a deactivated account, a refused create). A name
// nobody in the store has quietly does nothing — the Mac's rule (broadcast keywords never get here).
import { useCallback, useContext, useRef } from 'react';
import { data } from '../../../bridge/client';
import { ShellContext } from '../../shell/ShellContext';

export function useMentionOpener(fallback: (username: string, anchor?: { x: number; y: number }) => void) {
  const shell = useContext(ShellContext);
  const fallbackRef = useRef(fallback);
  fallbackRef.current = fallback;
  return useCallback(
    async (username: string, anchor?: { x: number; y: number }) => {
      const userId = await data.call('mentionTarget', username).catch(() => null);
      if (!userId) return;
      if (!shell) return fallbackRef.current(username, anchor);
      const r = await data.call('openDirectChannel', [userId]).catch(() => null);
      if (r && 'channelId' in r) shell.openChannel(r.channelId);
      else fallbackRef.current(username, anchor);
    },
    [shell],
  );
}
